// extracted by mini-css-extract-plugin
export default {"adHostResultTableContainer":"AdHostResultPage_adHostResultTableContainer__8n1-4"};